import styled from 'styled-components';

export default styled.div`
    border: 1px solid #E8E8E8;
    padding: 40px;
    @media (max-width: 768px) {
        border: none;
        padding: 0px;        
    }
`